<template>
    <div class="row">
        <div class="col-md-6 mb-1">
            <label class="form-label">Çalışma Grubu</label>
            <v-select-list v-model="workingGroup" :options="workingGroups" v-on:input="clearFirm" label="Name" placeholder="Çalışma Grubu Seçiniz"></v-select-list>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Firma</label>
            <v-select-list v-model="firm" :options="firms" label="Name" v-on:search="searchFirms" placeholder="Firma" :loading="firmsLoading" img="Logo"></v-select-list>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Araç</label>
            <v-select-list v-model="vehicle" :options="vehicles" label="Vehicle" placeholder="Araç Seçiniz"></v-select-list>

            <b-alert v-if="vehicle && vehicle.IsNeedHGS" variant="warning" show class="mt-1 mb-0">
                <div class="alert-body">
                    <feather-icon icon="AlertTriangleIcon" class="mr-50"></feather-icon>
                    <span><strong>Dikkat:</strong> Bu araç tipi için HGS tanımlaması zorunludur.</span>
                </div>
            </b-alert>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Plaka</label>
            <v-select-list v-model="vehiclePlate" :disabled="editing" :options="plates" label="PlateValue" placeholder="Plaka Seçiniz"></v-select-list>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Renk</label>
            <v-select-list v-model="colour" :options="colours" label="Name" placeholder="Renk Seçiniz"></v-select-list>
        </div>
    </div>
</template>

<script>
import SystemDataApi from "@/api/system-data";
import VehicleOperationsApi from "@/api/vehicle-operations";
import OperationalParametersApi from "@/api/operational-parameters";
import VehicleDefinitionsApi from "@/api/vehicle-definitions";
import FirmOperationsApi from "@/api/firm-operations";
import { BAlert } from "bootstrap-vue";

export default {
    components: { BAlert },
    props: {
        value: Object,
        editing: Boolean,
    },
    data() {
        return {
            workingGroups: [],
            vehicles: [],
            plates: [],
            colours: [],
            firms: [],
            firmsLoading: false,
        };
    },
    mounted() {
        if (!this.editing) {
            this.getWorkingGroups();
            this.getPlates();
        }
        this.getVehicles();
        this.getColours();
    },
    methods: {
        clearFirm() {
            this.firm = null;
            this.firms = [];
        },
        getWorkingGroups() {
            return new Promise((resolve) => {
                OperationalParametersApi.WorkingGroup.ListByVisible(true).then((response) => {
                    this.workingGroups = response.data.Data;
                    resolve(true);
                });
            });
        },
        getVehicles() {
            VehicleDefinitionsApi.Vehicle.List().then((response) => {
                this.vehicles = response.data.Data;
            });
        },
        getPlates(plate) {
            return new Promise((resolve, reject) => {
                VehicleOperationsApi.Plate.ListViaNotUsingWithUsingPlate(plate || null)
                    .then((response) => {
                        this.plates = response.data.Data;
                        resolve();
                    })
                    .catch((err) => {
                        reject();
                    });
            });
        },
        getColours() {
            SystemDataApi.Colour().then((response) => {
                this.colours = response.data.Data;
            });
        },
        searchFirms(search) {
            if (search) {
                this.firmsLoading = true;
                FirmOperationsApi.List(search, this.workingGroup.IsOwnFirm)
                    .then((res) => {
                        this.firms = res.data.Data;
                        this.firmsLoading = false;
                    })
                    .catch((err) => {
                        this.firmsLoading = false;
                    });
            }
        },
    },
    computed: {
        colour: {
            get: function () {
                return this.colours.find((b) => b.Id == this.value.ColourId);
            },
            set: function (value) {
                this.value.ColourId = value?.Id || null;
            },
        },
        workingGroup: {
            get: function () {
                return this.workingGroups.find((b) => b.Id == this.value.WorkingGroupId);
            },
            set: function (value) {
                this.value.WorkingGroupId = value?.Id || null;
            },
        },
        vehicle: {
            get: function () {
                return this.vehicles.find((b) => b.Id == this.value.VehicleId);
            },
            set: function (value) {
                this.value.VehicleId = value?.Id || null;
            },
        },
        vehiclePlate: {
            get: function () {
                return this.plates.find((b) => b.Id == this.value.VehiclePlateId);
            },
            set: function (value) {
                this.value.VehiclePlateId = value?.Id || null;
            },
        },
        firm: {
            get: function () {
                return this.firms.find((b) => b.Id == this.value.FirmId);
            },
            set: function (value) {
                this.value.FirmId = value?.Id || null;
            },
        },
    },
};
</script>
